export default __webpack_public_path__ + "static/media/forgot_pin.a3eab99d.svg";